import React from 'react';

/**
 * LoadingSpinner — Double concentric ring (Uiverse.io / devAaus)
 * Anel externo: cor primária (verde) — spin 1 s, horário
 * Anel interno: cor terciária (roxo) — spin 0.75 s, anti-horário
 *
 * Velocidades diferentes evitam que as rotações se cancelem mutuamente,
 * fazendo o anel interno parecer parado.
 *
 * Props:
 *  size   {'sm'|'md'|'lg'}  default: 'md'
 */
export function LoadingSpinner({ size = 'md' }) {
  const outer = {
    sm: 'h-10 w-10 border-[3px]',
    md: 'h-16 w-16 border-4',
    lg: 'h-20 w-20 border-4',
  }[size] ?? 'h-16 w-16 border-4';

  const inner = {
    sm: 'h-7 w-7 border-[3px]',
    md: 'h-11 w-11 border-4',
    lg: 'h-14 w-14 border-4',
  }[size] ?? 'h-11 w-11 border-4';

  return (
    <div
      className={`${outer} border-transparent animate-spin flex items-center justify-center rounded-full`}
      style={{ borderTopColor: 'var(--color-primary, #51e1a5)' }}
    >
      <div
        className={`${inner} border-transparent animate-spin flex items-center justify-center rounded-full`}
        style={{
          borderTopColor: 'var(--color-tertiary, #d1c0ff)',
          animationDirection: 'reverse',
          animationDuration: '0.75s',
        }}
      />
    </div>
  );
}
